import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Translation version - increment this when translations are updated
const TRANSLATION_VERSION = '62';

i18n
  // Load translation files from public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    backend: {
      // Path to translation files with cache busting
      loadPath: `/locales/{{lng}}.json?v=${TRANSLATION_VERSION}`,
    },

    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Cache user language preference
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      // Enable Suspense for translations loading
      useSuspense: true,
    },
  });

export default i18n;
